import { Component, OnInit } from "@angular/core";
import { VproService } from "./../../service/vpro/vpro.service";
import { Extend } from "./../../models/extend";
import { DashCred } from "./../../models/dash";
import Swal from "sweetalert2";
import { Organisation } from "src/app/models/organisation";
import { Router } from "@angular/router";

@Component({
  selector: "app-expand-register",
  templateUrl: "./expand-register.component.html",
  styleUrls: ["./expand-register.component.css"]
})
export class ExpandRegisterComponent implements OnInit {
  extend = new Extend();
  submitted = false;
  organisation = new Organisation();
  dcred = new DashCred();
  usereid: string;
  prodet: any;

  constructor(private extendService: VproService, private router: Router) { }

  ngOnInit() {
    //localStorage.getItem('getOrg');
    this.extend.email = localStorage.getItem("LogUsr");
    this.extend.altemail = localStorage.getItem("LogUsr");
    this.extend.u_type = 2;
    this.getOrgDet(this.usereid);
    this.extend.first_name = localStorage.getItem("first_name");
    this.extend.last_name = localStorage.getItem("last_name");
  }

  getOrgDet(usereid: string) {
    try {
      this.extendService.getOrgDet(this.dcred).subscribe(
        res => {
          this.prodet = res;
          for (let i of this.prodet) {
            this.extend.org_code = i.org_code;
          }
        },
        error => {
          console.log(error);
        }
      );
    } catch (excep) {
      console.log(excep);
    }
  }

  /*   async addExtend() {
      // console.log(userForm)
      this.submitted = true;
      this.save();
    } */

  private save(): void {
    console.log(this.extend);
    let data = {};
    data['u_id'] = localStorage.getItem("uid");
    /* data['physician_education'] = [{
      degree: this.extend.qualification,
      institution: this.extend.institution,
    }];
    data['physician_experience'] = [{
      employer: this.extend.expertise

    }] */
    this.extendService.addExtend(data).subscribe(
      resp => {
        const Toast = Swal.mixin({
          toast: true,
          position: "top",
          showConfirmButton: false,
          timer: 3500,
        });
        Toast.fire({
          type: "success",
          title: "Profile Extended successfuly",
        });
      },
      err => {
        console.log(err);
        const Toast = Swal.mixin({
          toast: true,
          position: "top",
          showConfirmButton: false,
          timer: 3500,
        });
        Toast.fire({
          type: "error",
          title: "Something went wrong. Please try again.",
        });
      }
    );
  }
  /*   catch(excep) {
      console.log(excep);
    } */


  extendProfile() {
    this.save();
  }

}
